import { Abacus } from "Javascript/core/Abacus.Core";
import { Class } from "Javascript/core/Abacus.Utilities";
import { SpinnerClass } from "Javascript/core/classes/spinner.class";
import { SwiperClass } from "Javascript/core/classes/swiper/swiper.class";
import { MediaQueryPublisher } from "Javascript/core/classes/media.query.publisher.class";
import { ScrollDebouncer } from "Javascript/core/classes/scroll/scroll.debouncer.class";

let zoomOptions = {
  minZoomLevel: 0,
  maxZoomLevel: 6,
  scaleMultipliers: [1, 2, 1.5, 1.334, 1.25, 1.2],
  zoomScale: 1.2
};

class ImageZoom extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.body = this.element.parents("body");
    this.setOptions(zoomOptions, options);
    if (!this.supportsTransforms()) {
      this.logSupportMessage();
      return;
    }
    this.$srcImage = this.element.find("img");
    if (!this.$srcImage.length) {
      return;
    }
    this.zoomLevel = 0;
    this.loading = true;
    this.setUpEvents();
    this.addButtonZoomClass();
    this.addButtonTray();
    this.updateZoomButtons();
    this.onStart = this.onStart.bind(this);
    this.onMove = this.onMove.bind(this);
    this.onEnd = this.onEnd.bind(this);
    this.resetTransformData();
  }

  initialTransformData() {
    return {
      startX: 0,
      currentX: 0,
      endX: 0,
      startY: 0,
      currentY: 0,
      endY: 0,
      screenX: 0,
      screenY: 0,
      imageWidth: 0,
      originXPercentation: 50,
      originYPercentation: 50,
      dragging: false
    };
  }

  setUpEvents() {
    var self = this;

    this.element.on("click", ".zoom-in", function(e) {
      self.incrementZoomLevel();
      self.render();
      e.preventDefault();
    });

    this.element.on("click", ".zoom-out", function(e) {
      self.decrementZoomLevel();
      self.render();
      e.preventDefault();
    });

    $(window).on("resize", function() {
      setTimeout(function() {
        self.setZoomImagePosition();
      }, 16);
    });
  }

  setUpMoveEvents() {
    this.$zoomImage.on("touchstart", this.onStart);
    $(document).on("touchmove", this.onMove);
    $(document).on("touchend", this.onEnd);
    this.$zoomImage.on("mousedown", this.onStart);
    $(document).on("mousemove", this.onMove);
    $(document).on("mouseup", this.onEnd);
  }

  getZoomImage() {
    var src;
    if (this.$srcImage.attr("data-srcset")) {
      src = this.$srcImage
        .attr("data-srcset")
        .split(",")[0]
        .replace(/\w+$/, "");
    } else {
      src = this.$srcImage.attr("src");
    }
    var newSrc = this.getURL(src, "3000xAny");
    return $("<img/>")
      .attr("src", newSrc)
      .addClass("zoomable-image")
      .addClass("zoomable-transition");
  }

  getURL(src, size) {
    //re =
    //starts with '/'
    //followed by (a number or any)
    //followed by 'x'
    //followed by (a number or any)
    //ends with '/'
    // http://www.regexr.com/393et
    var re = /\/(\d+|any|Any)x(\d+|\d+(fit|pad|fitpad|fitpad\[(.*?)\])|\d+(-\d+)|Any(|fit|pad|fitpad|fitpad\[(.*?)\])|Any(-\d+))\//gi;
    return src.replace(re, "/" + size + "/");
  }

  zoomImageIsLoaded(callback) {
    return $(this.$zoomImage).one("load", callback);
  }

  addButtonZoomClass() {
    this.element.addClass("zoomable");
  }

  addButtonTray() {
    var self = this;

    if (
      self.element.find(".button-tray").length >= 1 ||
      self.element.find(".button-tray").length != 1
    ) {
      self.element.find(".button-tray").remove();

      this.element.append('<div class="button-tray"></div>');
      this.$zoomIn = $(
        '<a href="#" class="zoomable-button zoom-in">zoom in</a>'
      );
      this.$zoomOut = $(
        '<a href="#" class="zoomable-button zoom-out">zoom out</a>'
      );

      self.element
        .find(".button-tray")
        .append(this.$zoomIn)
        .append(this.$zoomOut);
    }
    this.updateZoomButtons();
  }

  updateZoomButtons() {
    if (this.canZoomIn()) this.$zoomIn.removeClass("disabled");
    else this.$zoomIn.addClass("disabled");
    if (this.canZoomOut()) this.$zoomOut.removeClass("disabled");
    else this.$zoomOut.addClass("disabled");
  }

  supportsTransforms() {
    return $("html").hasClass("csstransforms");
  }

  logSupportMessage() {
    console.log(
      "Abacus.ImageZoom: This browser does not support CSS transforms and therefore image zoom is not supported."
    );
  }

  incrementZoomLevel() {
    if (this.canZoomIn()) {
      this.zoomLevel++;
      this.tweakEndCoordinates(true);
      this.switchOffSwipingLibrary();
    }
  }

  decrementZoomLevel() {
    var self = this;
    if (this.canZoomOut()) {
      this.zoomLevel--;
      this.tweakEndCoordinates(false);
    }
    if (!this.canZoomOut()) {
      //reset once the zoom animation has finished
      setTimeout(function() {
        self.resetTransformData();
      }, 500);
    }
  }

  canZoomIn() {
    return this.zoomLevel < this.options.maxZoomLevel;
  }

  canZoomOut() {
    return this.zoomLevel > this.options.minZoomLevel;
  }

  render() {
    this.loadZoomImage();
    this.loadingState();
    this.updateZoomButtons();
    this.updateImageZoom();
  }

  loadZoomImage() {
    var self = this;
    if (!this.$zoomImage) {
      if (this.srcImageIsSvg()) {
        this.$zoomImage = this.$srcImage;
        this.loading = false;
        this.setUpMoveEvents();
      } else {
        this.$zoomImage = self.getZoomImage();
        this.zoomImageIsLoaded(function() {
          //Fix for IE 10 adding height and width attrs to image
          self.$zoomImage.removeAttr("height");
          self.$zoomImage.removeAttr("width");
          self.$srcImage.after(self.$zoomImage);
          self.setZoomImagePosition();
          self.loading = false;
          self.setUpMoveEvents();
          setTimeout(function() {
            self.render();
          }, 150);
        });
      }
    }
  }

  setZoomImagePosition() {
    if (!this.$zoomImage) return;
    var position = this.$srcImage.position();
    var mHeight = this.$srcImage.css("max-height");
    this.$zoomImage.parent().css({
      display: "flex",
      "justify-content": "center",
      "align-items": "center",
      "max-height": mHeight
    });
    if (!this.srcImageIsSvg()) {
      this.$srcImage.css({
        visibility: "hidden"
      });
    }
    if (!!this.$zoomImage.parents(".gallery-attachments").length) {
      this.$zoomImage.parent().css({
        display: "flex",
        "justify-content": "center",
        "align-items": "center",
        height: "100vh",
        "max-height": mHeight
      });
    }
    if (!!this.$zoomImage.parents(".fullsize").length) {
      this.$zoomImage.css({
        top: position.top + "px",
        left: position.left + "px",
        "max-height": mHeight
      });
    }
    if (!!this.$zoomImage.parents(".inlineGallery").length) {
      this.$zoomImage.css({
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
        margin: "auto",
        "max-height": mHeight
      });
    } else {
      this.$zoomImage.css({
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
        margin: "auto",
        "max-height": mHeight
      });
    }
  }

  srcImageIsSvg() {
    return this.$srcImage.attr("src").indexOf(".svg") > 0;
  }

  loadingState() {
    var self = this;
    if (this.loading && !this.$loading) {
      this.$loading = $("<div/>").addClass("zoomable-loading zoomHide");
      self.spinner = new SpinnerClass(this.$loading, {
        spinnerOptions: {
          color: "#fff"
        }
      });
      this.$srcImage.after(this.$loading);
      requestAnimationFrame(function() {
        self.$loading.removeClass("zoomHide");
      });
    }
    if (!this.loading && this.$loading) {
      this.$loading.addClass("zoomHide");
      setTimeout(function() {
        self.spinner.hide();
      }, 500);
    }
  }

  updateImageZoom() {
    var self = this;
    if (!this.$zoomImage || this.loading) return;
    requestAnimationFrame(function() {
      var zoomAmount = self.getZoomAmount();
      var transform = "scale(" + zoomAmount + ")";
      var transformOrigin =
        self.transformData.originXPercentation +
        "% " +
        self.transformData.originYPercentation +
        "%";

      if (self.transformData.dragging) {
        self.$zoomImage.removeClass("zoomable-transition");
        self.$zoomImage.addClass("is-dragging");
      } else {
        self.$zoomImage.addClass("zoomable-transition");
        self.$zoomImage.removeClass("is-dragging");
      }

      if (self.canZoomOut()) {
        self.$zoomImage.addClass("is-draggable");
      } else {
        self.$zoomImage.removeClass("is-draggable");
        self.switchOnSwipingLibrary();
      }

      var $imageZoom = self.$zoomImage.get(0);
      var style = $imageZoom.style;
      style.webkitTransform = style.MsTransform = style.msTransform = style.MozTransform = style.OTransform = style.transform = transform;
      style.webkitTransformOrigin = style.WebkitTransformOrigin = style.msTransformOrigin = style.MsTransformOrigin = style.transformOrigin = transformOrigin;

      if (self.transformData.dragging) {
        self.updateImageZoom.bind(self)();
      }
    });
  }

  getZoomAmount() {
    return 1 + this.zoomLevel * this.options.zoomScale;
  }

  onStart(e) {
    if (!this.canZoomOut()) return;
    var event = e.originalEvent;
    this.transformData.startX = event.pageX || event.touches[0].pageX;
    this.transformData.startY = event.pageY || event.touches[0].pageY;
    this.transformData.currentX = this.transformData.startX;
    this.transformData.currentY = this.transformData.startY;
    this.transformData.imageWidth = this.$zoomImage.width();
    this.transformData.imageHeight = this.$zoomImage.height();
    this.transformData.dragging = true;
    this.render();
    if (!event.touches) {
      e.preventDefault();
    }
  }

  onMove(e) {
    if (!this.canZoomOut()) return;
    if (!this.transformData.dragging) return;
    this.body.addClass("moving");
    var event = e.originalEvent;
    var zoomAmount = this.getZoomAmount() - 1;
    var prevScreenX = this.transformData.screenX;
    var prevScreenY = this.transformData.screenY;
    this.transformData.currentX = event.pageX || event.touches[0].pageX;
    this.transformData.currentY = event.pageY || event.touches[0].pageY;
    var diffX =
      this.transformData.endX +
      this.transformData.currentX -
      this.transformData.startX;
    var diffY =
      this.transformData.endY +
      this.transformData.currentY -
      this.transformData.startY;
    this.transformData.screenX = diffX;
    this.transformData.screenY = diffY;
    this.updateImageBoundaries();
    //reset screenX / Y if boundaries have been exceeded
    if (
      this.transformData.originXPercentation <= 0 ||
      this.transformData.originXPercentation >= 100
    ) {
      this.transformData.screenX = prevScreenX;
    }
    if (
      this.transformData.originYPercentation <= 0 ||
      this.transformData.originYPercentation >= 100
    ) {
      this.transformData.screenY = prevScreenY;
      if (!event.touches) {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
    }
  }

  onEnd(e) {
    if (!this.canZoomOut()) return;
    if (!this.transformData.dragging) return;
    this.body.removeClass("moving");
    var event = e.originalEvent;
    this.transformData.endX = this.transformData.screenX;
    this.transformData.endY = this.transformData.screenY;
    this.transformData.dragging = false;
  }

  updateImageBoundaries() {
    var zoomAmount = this.getZoomAmount() - 1;
    var imageWidth = this.transformData.imageWidth;
    var imageHeight = this.transformData.imageHeight;
    var screenXZoomOffset = this.transformData.screenX / zoomAmount;
    var screenYZoomOffset = this.transformData.screenY / zoomAmount;
    this.transformData.originXPercentation = Math.max(
      0,
      Math.min(100, -1 * ((100 / imageWidth) * screenXZoomOffset) + 50)
    );
    this.transformData.originYPercentation = Math.max(
      0,
      Math.min(100, -1 * ((100 / imageHeight) * screenYZoomOffset) + 50)
    );
  }

  resetTransformData() {
    this.transformData = this.initialTransformData();
  }

  tweakEndCoordinates(zoomingIn) {
    var multiplierIndex = this.zoomLevel - (zoomingIn ? 1 : 0);
    var multiple = this.options.scaleMultipliers[multiplierIndex];
    var zoomAmount = zoomingIn ? multiple : 1 / multiple;
    this.transformData.endX = this.transformData.endX * zoomAmount;
    this.transformData.endY = this.transformData.endY * zoomAmount;
  }

  switchOffSwipingLibrary() {
    this.$srcImage.parents(".swiper-slide").addClass("swiper-no-swiping");
  }

  switchOnSwipingLibrary() {
    this.$srcImage.parents(".swiper-slide").removeClass("swiper-no-swiping");
  }
}

export { ImageZoom };



// WEBPACK FOOTER //
// ./Javascript/core/classes/zoom/image.zoom.class.js